module.exports = __webpack_public_path__ + "static/img/noMessage.0b2709c4.png";